import React, { useMemo, useCallback } from 'react'
import { useShoppingCartContext } from '../../providers/ShoppingCartProvider'
import Warning from './Types/Warning'

const linkStyle = { color: '#05629B' }

const VendorItemsAddFailed = () => {
  const {
    vendorItemsAddFailed,
    setVendorItemsAddFailed,
  } = useShoppingCartContext()

  const handleClose = useCallback(
    () => {
      setVendorItemsAddFailed(false)
    },
    [setVendorItemsAddFailed],
  )

  const style = useMemo(
    () => ({ fontSize: '16px' }),
    [],
  )

  const message = useMemo(
    () => (
      <span style={style}>
        <b>Important!</b>
        {' '}
        The Coverking item is no longer available.
        {' '}
        <a href="/search?q=coverking" style={linkStyle}>Go back</a>
        {' '}
        to try again.
      </span>
    ),
    [style],
  )

  if (!vendorItemsAddFailed) return null

  return (
    <Warning
      id="vendorItemsAddFailedNotif"
      message={message}
      timeout={30000}
      cb={handleClose}
    />
  )
}

export default VendorItemsAddFailed
